import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import SchoolViewModel from '../ViewModels/SchoolViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface ISchoolDropDownProps {
    setSchool?: (event) => void;
    school: string | undefined;
    disabled: boolean;
    childMode: boolean;
}

interface ISchoolDropDownState {
    model: SchoolViewModel[];
    loaded: boolean;
}

class SchoolDropDown extends Component<ISchoolDropDownProps & WithStyles<typeof styles>, ISchoolDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetSchools?under16=' + this.props.childMode).then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultSchoolVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.childMode ? "Which school did your child last attend? *" : "Which school did you last attend? *"}
                name="school"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.school}
                onChange={this.props.disabled ? undefined : this.props.setSchool}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(SchoolDropDown);